import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n"
import router from "@/lib/router";

const BASE_PATH = "/restitution-templates";
const CREATE_PATH = `${BASE_PATH}/create`;

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.restitutionTemplates": "Modèles de restitution",
			"breadcrumb.restitutionTemplates.create": "Créer",
			"breadcrumb.restitutionTemplates.edit": "Modifier"
		});

		breadcrumb.add([
			{
				path: BASE_PATH,
				name: "home>database>restitutionTemplates",
			},
			{
				path: CREATE_PATH,
				name: "home>database>restitutionTemplates>restitutionTemplates.create",
			},
			{
				path: `${BASE_PATH}/(\\d+)`,
				name: "home>database>restitutionTemplates>restitutionTemplates.edit",
			}
		]);

		router.addRoutes([
			{
				name: RestitutionTemplatesRouteName.LIST,
				path: BASE_PATH,
				component: () => import("./vues/RestitutionTemplatesList.vue"),
				meta: {
					secured: true
				}
			},
			{
				name: RestitutionTemplatesRouteName.CREATE,
				path: CREATE_PATH,
				component: () => import("./vues/RestitutionTemplatesAddEdit.vue"),
				meta: {
					secured: true
				}
			},
			{
				name: RestitutionTemplatesRouteName.EDIT,
				path: `${BASE_PATH}/:id(\\d+)`,
				component: () => import("./vues/RestitutionTemplatesAddEdit.vue"),
				props: route => ({ id: parseInt(route.params.id, 10) }),
				meta: {
					secured: true
				}
			}
		]);
	}
}

export enum RestitutionTemplatesRouteName {
	LIST = "restitutionTemplates.list",
	CREATE = "restitutionTemplates.create",
	EDIT = "restitutionTemplates.edit"
}
